import {
  MockMap,
  utils,
} from '@ama-sdk/core';
import {
  Email,
  Journey,
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  AcceptanceRepository,
  BaggageRepository,
  combineBoardingPassResults,
  combineCheckInBaggagePolicies,
  combineJourneys,
  createJourney,
  createJourneyTraveler,
  createMockData,
  createMockDataWithResponse,
  RecursivePartial,
  RegulatoryDetailsReplyDataRepository,
} from '@dapi/sdk/spec';
import {
  seatmap,
} from '../../mock/data';
import {
  globalDob,
} from '../../mock/dictionaries/dates';

const email: Email = {
  address: 'christophe.bernard@amadeus.com',
  category: 'personal',
  contactType: 'Email',
  purpose: 'notification'
};

const journeyTemplate: RecursivePartial<Journey> = {
  contacts: [email],
  travelers: [
    createJourneyTraveler({
      template: {
        dateOfBirth: new utils.Date(globalDob),
        gender: 'male',
        names: [
          {
            firstName: 'TEST',
            lastName: 'BERNARD',
            title: 'MR'
          }
        ]
      }
    })
  ]
};

const journeys = combineJourneys([journeyTemplate, journeyTemplate]).items;
const journeyElementIds = journeys[0].journeyElements.map((je: JourneyElementCommon) => je.id);

/**
 * RT 2 journeys
 * 1ADT
 * No baggage
 */
export const rt2Journeys1AdtRetrieve: MockMap = {
  generateBoardingPasses: [createMockDataWithResponse(combineBoardingPassResults(undefined, {
    journeyElementIds
  }).items, 201)],
  getBaggagePoliciesFromJourney: [createMockData(combineCheckInBaggagePolicies().items)],
  getJourneyUnpaidItems: [createMockDataWithResponse(undefined, 404, [{
    code: '10000',
    title: 'No unpaid service',
    type: 'error',
    id: '10000'
  }])],
  getRegulatoryDetails: [createMockData(RegulatoryDetailsReplyDataRepository.DEFAULT)],
  requestAcceptanceOfJourney: [createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201), createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)],
  retrieveJourneyBaggages: [createMockData([BaggageRepository.DEFAULT])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }, journeys[1]], 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }, {
      ...journeys[1],
      acceptance: AcceptanceRepository.ACCEPTED
    }], 201),
    createMockDataWithResponse([{
      ...journeys[0],
      acceptance: AcceptanceRepository.ACCEPTED
    }, {
      ...journeys[1],
      acceptance: AcceptanceRepository.ACCEPTED
    }], 201)
  ],
  retrieveJourney: [
    createMockData(createJourney({
      template: {
        ...journeys[0],
        acceptance: AcceptanceRepository.ACCEPTED
      }
    })),
    createMockData(createJourney({
      template: {
        ...journeys[1],
        acceptance: AcceptanceRepository.ACCEPTED
      }
    }))
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)]
};
